<template>
  <div>
    <surveys-table
      surveyName="BSA"
      surveyCode="BSA"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_BSA,
        viewDetail: permissions.SEE_DETAIL_SURVEY_BSA,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
